import { FC } from "react";
import cx from "classnames";
import starIcon from "../../assets/icons/filled-star.svg";

interface ReviewItemProps {
  comment: string;
  author: string;
  authorTitle: string;
  image?: string;
  withCard?: boolean;
}

const ReviewItem: FC<ReviewItemProps> = ({
  comment,
  author,
  authorTitle,
  image,
  withCard = true,
}) => {
  const quotedComment = `„${comment}“`;

  return (
    <>
      {/* md:min-h-[282px] */}
      <div
        className={cx(
          withCard == true
            ? "bg-grey-200 border-stroke rounded-[18px] border-[1px] py-[40px]"
            : "-mb-3",
          "flex flex-col justify-between px-[24px] text-center md:min-h-auto md:px-[40px]",
        )}
      >
        <div className="flex w-full justify-center gap-[2px]">
          {Array.from({ length: 5 }, (_, index) => (
            <img key={index} src={starIcon} alt="start icon" className="w-7" />
          ))}
        </div>
        <p className="text-primary my-5 overflow-y-auto whitespace-pre-line italic md:text-lg">
          {quotedComment}
        </p>
        <div className="flex flex-col items-center justify-center gap-2">
          {image ? (
            <img
              src={image}
              alt={author}
              loading="lazy"
              className="h-12 w-12 shrink-0 rounded-full bg-gray-200 object-cover ring-1 ring-gray-200"
            />
          ) : (
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-500">
              <span className="font-semibold text-white md:text-lg">
                {author.charAt(0)}
              </span>
            </div>
          )}
          <div className="text-center">
            <div className="flex items-center justify-center gap-2">
              <p className="text-dark text-[20px] font-light">{author}</p>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M5.5 8L7 9.5L10.5 6M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
                  stroke="#2196F3"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <p className="text-grey-400 text-sm">{authorTitle}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewItem;
